import { STATISTICS_COOKIE_NAME_PREFIXES } from '../constants';
import { CookieConsentType } from '../models/cookie-consent-type.enum';

function optOutStatistics() {
  localStorage.removeItem('78b9b1fe-b589-4cb3-af4e-aae70e955cb5');

  document.cookie
    .split(';')
    .map((cookie) => cookie.split('=')[0])
    .filter((cookieName) =>
      STATISTICS_COOKIE_NAME_PREFIXES.find((prefix) =>
        cookieName.startsWith(prefix)
      )
    )
    .map((cookieName) => `${cookieName}=;expires=${new Date(0).toUTCString()}`)
    .forEach((clearedCookie) => (document.cookie = clearedCookie));
}

export function optOut(consentType: CookieConsentType) {
  switch (consentType) {
    case CookieConsentType.Statistics:
      return optOutStatistics();
    default:
      break;
  }
}
